import dayjs from "dayjs";
import { AlignedData } from "uplot";

import { SymbolPrice } from "@/features/analysis/backtest/services/symbol-prices";

import { TradeInfo } from "../services/insider-buying-top5";

type Date = number;
type Price = number;
type Signal = number;
type PlotData = [Date[], Price[], Signal[]];

export const getTop5PlotData = ({
  tradeInfoData,
  pricesData,
}: {
  tradeInfoData: TradeInfo[];
  pricesData: SymbolPrice[];
}): AlignedData => {
  const result: PlotData = [[], [], []];
  if (!tradeInfoData || !pricesData) return result;

  const tradeInfoMap = tradeInfoData.reduce((acc, cur) => {
    if (cur.tradeAt && cur.actionSeries) acc[cur.tradeAt] = cur.actionSeries;
    return acc;
  }, {} as Record<string, string>);

  pricesData.forEach(({ date, closePrice }) => {
    result[0].push(dayjs(date).unix());
    result[1].push(closePrice);

    const actionSeries = tradeInfoMap[date];
    result[2].push(
      actionSeries
        ? actionSeries.startsWith("B")
          ? +actionSeries.slice(1)
          : -actionSeries.slice(1)
        : 0
    );
  });
  return result;
};
